import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityHeaderBlueprint } from '@backstage/plugin-catalog-react/alpha';

/*
 * One header for every kind. `EntityHeaderBlueprint`'s `filter` could give a
 * kind its own header, but the differences the mock draws are per-entity rather
 * than per-kind — a source link, a runbook link — so the header adapts on the
 * data it finds instead of on the kind. Registered without a filter, which also
 * makes it the fallback for any kind a filtered header might later be added for.
 */
const entityPageHeader = EntityHeaderBlueprint.make({
  name: 'hone-entity-header',
  params: {
    loader: async () =>
      import('./EntityPageHeader').then(m => <m.EntityPageHeader />),
  },
});

export const entityHeaderModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [entityPageHeader],
});
